<template>
  <div class="mt20 p20 tc viewpoints">
    <img
      class="mb5 viewpoints-img"
      :src="`${userCommonImageUrlForPc}/viewpoints.png`"
      alt="viewpoints"
      data-test="viewpoints-img"
    >
    <h3 class="fs15 fwB">
      女の転職！取材レポート
    </h3>
    <div class="plr5 mt20">
      <div>
        <job-preview-right-column
          :text-count-mode="textCountMode"
          :highlight-mode="highlightMode"
          comment-class="report"
          :comment-highlights="getAnyCommentHighlights(targetIdMap.report.staffComment.prefix)"
          text-count-class="report"
          :text-counts="textCounts.staff"
          v-on="$listeners"
        />
        <div class="clearfix">
          <h4
            v-if="report.name"
            :id="targetIdMap.report.staffComment.name"
            class="tl fwB fs14"
            data-test="name"
            v-text="`取材担当${report.name}より`"
          />
          <p
            :id="targetIdMap.report.staffComment.body"
            class="tl fs13 pega-pre-wrap"
            data-test="body"
            v-text="report.body"
          />
        </div>
      </div>
      <div
        v-if="report.improve"
        data-test="improve"
      >
        <job-preview-right-column
          :text-count-mode="textCountMode"
          :highlight-mode="highlightMode"
          comment-class="report"
          :comment-highlights="getCommentHighlights(targetIdMap.report.improve)"
          text-count-class="report"
          :text-counts="[getTextCount('この仕事で磨ける経験・能力', report.improve, targetIdMap.report.improve)]"
          v-on="$listeners"
        />
        <div class="clearfix">
          <h4 class="tl fwB fs14 mt15">
            この仕事で磨ける経験・能力
          </h4>
          <p
            :id="targetIdMap.report.improve"
            class="tl fs13 pega-pre-wrap"
            data-test="improve-text"
            v-text="report.improve"
          />
        </div>
      </div>
    </div>

    <template v-if="interviews.length">
      <h4 class="fs14 fwB mt20 tc interview">
        社員の方にインタビューしました
      </h4>
      <template v-for="(interview) in interviews">
        <div
          :key="`interview-${interview.index}`"
          class="clearfix fs13 p20 interview-row"
          :data-test="`interview-${interview.index}`"
        >
          <job-preview-right-column
            :text-count-mode="textCountMode"
            :highlight-mode="highlightMode"
            comment-class="interview"
            :comment-highlights="getAnyCommentHighlights(targetIdMap.freeTopics.prefix, interview.index)"
            text-count-class="interview"
            :text-counts="textCounts.interviews(interview, interview.index)"
            v-on="$listeners"
          />
          <dl class="fll tl row-left">
            <dt
              v-if="interview.title"
              :id="`${targetIdMap.freeTopics.title}-${interview.index}`"
              class="fwB mb5"
              :data-test="`interview-title-${interview.index}`"
              v-text="interview.title"
            />
            <dd
              :id="`${targetIdMap.freeTopics.body}-${interview.index}`"
              class="pega-pre-wrap"
              :data-test="`interview-body-${interview.index}`"
              v-text="interview.body"
            />
          </dl>
          <div class="flr">
            <img
              v-if="interview.photo"
              :id="`${targetIdMap.freeTopics.photo}-${interview.index}`"
              :src="getPhotoUrl(interview.photo)"
              class="offer-img-sub"
              :data-test="`photo-${interview.index}`"
              @load="$emit('onLoadImage')"
              @error="$emit('onLoadImage')"
            >
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'

export default {
  components: {
    JobPreviewRightColumn
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight],
  props: {
    report: {
      type: Object,
      default: () => {}
    },
    interviews: {
      type: Array,
      default: () => []
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    textCounts () {
      return {
        staff: [
          this.getTextCount('担当者名字', this.report.name, this.targetIdMap.report.staffComment.name),
          this.getTextCount('レポート本文', this.report.body, this.targetIdMap.report.staffComment.body)
        ],
        interviews: (interview, index) => {
          return [
            this.getTextCount(`フリートピックス[${index}]タイトル`, interview.title, this.targetIdMap.freeTopics.title),
            this.getTextCount(`フリートピックス[${index}]本文`, interview.body, this.targetIdMap.freeTopics.body)
          ]
        }
      }
    }
  }
}
</script>
